import { all, call, put, takeLatest } from 'redux-saga/effects';
import api from '../../services/api';
import {
  LIST_DIAGNOSTICS_REQUEST,
  GET_DIAGNOSTIC_REQUEST,
  ADD_DIAGNOSTIC_REQUEST,
  EDIT_DIAGNOSTIC_REQUEST,
  DELETE_DIAGNOSTIC_REQUEST,
  LINK_DIAGNOSTIC_SUBJECTS_REQUEST,
  GET_DIAGNOSTIC_SUBJECTS_REQUEST,
} from '../actions';
import {
  listDiagnosticsSuccess,
  listDiagnosticsError,
  getDiagnosticSuccess,
  getDiagnosticError,
  addDiagnosticSuccess,
  addDiagnosticError,
  editDiagnosticSuccess,
  editDiagnosticError,
  deleteDiagnosticSuccess,
  deleteDiagnosticError,
  linkDiagnosticSubjectsSuccess,
  linkDiagnosticSubjectsError,
  getDiagnosticSubjectsSuccess,
  getDiagnosticSubjectsError,
} from './actions';

function* listDiagnostics() {
  try {
    const response = yield call(api.get, 'diagnostics');
    yield put(listDiagnosticsSuccess(response.data.data));
  } catch (error) {
    yield put(listDiagnosticsError(error));
  }
}

function* getDiagnosticById({ payload }) {
  try {
    const response = yield call(api.get, `diagnostics/${payload.id}`);
    yield put(getDiagnosticSuccess(response.data.data));
  } catch (error) {
    yield put(getDiagnosticError(error));
  }
}

const addDiagnosticAsync = async (data) =>
  api
    .post('diagnostics', data)
    .then((r) => r)
    .catch((e) => e);

const editDiagnosticAsync = async (data) =>
  api
    .put(`diagnostics/${data.id}`, data)
    .then((r) => r)
    .catch((e) => e);

function* addDiagnostic({ payload }) {
  try {
    const res = yield call(addDiagnosticAsync, payload.diagnostic);
    if (!res.response) {
      yield put(addDiagnosticSuccess(res.data.data));
    } else {
      yield put(addDiagnosticError(res.response.data));
    }
  } catch (error) {
    yield put(addDiagnosticError(error));
  }
}

function* editDiagnostic({ payload }) {
  try {
    const res = yield call(editDiagnosticAsync, payload.diagnostic);
    if (!res.response) {
      yield put(editDiagnosticSuccess(res.data.data));
    } else {
      yield put(editDiagnosticError(res.response.data));
    }
  } catch (error) {
    yield put(editDiagnosticError(error));
  }
}

const deleteDiagnosticAsync = async (id) =>
  api.delete(`diagnostics/${id}`);

function* deleteDiagnostic({ payload }) {
  try {
    const res = yield call(deleteDiagnosticAsync, payload.id);
    if (res.status >= 200 && res.status < 300) {
      yield put(deleteDiagnosticSuccess(payload.id));
    } else {
      yield put(deleteDiagnosticError(res.data));
    }
  } catch (error) {
    yield put(deleteDiagnosticError(error.response?.data ?? error));
  }
}

const linkSubjectsAsync = async ({ id, subjectIds }) =>
  api
    .post(`diagnostics/${id}/subjects`, {
      subjects: subjectIds.map((subjectId) => ({ id: subjectId })),
    })
    .then((r) => r)
    .catch((e) => e);

function* linkDiagnosticSubjects({ payload }) {
  try {
    const res = yield call(linkSubjectsAsync, payload);
    if (!res.response) {
      yield put(linkDiagnosticSubjectsSuccess());
    } else {
      yield put(linkDiagnosticSubjectsError(res.response.data));
    }
  } catch (error) {
    yield put(linkDiagnosticSubjectsError(error));
  }
}

function* getDiagnosticSubjects({ payload }) {
  try {
    const response = yield call(api.get, `diagnostics/${payload.id}/subjects`);
    yield put(getDiagnosticSubjectsSuccess(response.data.data));
  } catch (error) {
    yield put(getDiagnosticSubjectsError(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(LIST_DIAGNOSTICS_REQUEST, listDiagnostics),
    takeLatest(GET_DIAGNOSTIC_REQUEST, getDiagnosticById),
    takeLatest(ADD_DIAGNOSTIC_REQUEST, addDiagnostic),
    takeLatest(EDIT_DIAGNOSTIC_REQUEST, editDiagnostic),
    takeLatest(DELETE_DIAGNOSTIC_REQUEST, deleteDiagnostic),
    takeLatest(LINK_DIAGNOSTIC_SUBJECTS_REQUEST, linkDiagnosticSubjects),
    takeLatest(GET_DIAGNOSTIC_SUBJECTS_REQUEST, getDiagnosticSubjects),
  ]);
}
